/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Modal,
  Button,
  FormGroup,
  Form,
  Col,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import ControlTips from 'loracoms/ControlTips';
import Select from 'loracoms/Select';
import enumsActions from 'loraactions/enums';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { enumsToOptions } from 'lorautils/api/selector';
import callAPI from '@/api/callAPI';
import { isHexString } from 'lorautils/checkers/numbers';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  bandsOpts: PropTypes.array.isRequired,
  showModal: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  getBands: PropTypes.func.isRequired,
  appId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

const kRX2DROptions = _.range(16).map(v => ({
  value: v,
  label: String(v),
}));

class AddModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showModal,
      bandsOpts: [],
      errors: ErrorSet.createEmpty(),
      submitted: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.broadcast');
    this.handleChangeName = this.handleChangeName.bind(this);
  }

  componentWillMount() {
    this.props.getBands();
  }

  componentWillReceiveProps(nextProps) {
    const { showModal, bandsOpts, data } = nextProps;
    if (showModal !== this.props.showModal) {
      this.setState({ showModal });
    }
    if (data !== this.props.data) {
      const { name, band, rx2dr, rx2freq, appskey, nwkskey, fcntdown } = data;
      this.setState({
        name,
        band,
        rx2dr,
        rx2freq: !_.isNil(rx2freq) ? Number(rx2freq / 10000).toFixed(4) : rx2freq,
        appskey,
        nwkskey,
        fcntdown,
      });
    }
    this.setState({ bandsOpts });
  }

  checkKeys(key, val, errors = this.state.errors) {
    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!isHexString(val, { len: 32 })) {
      return errors.add(
        'FE_INVALIDAPPKEY',
        key,
        { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') },
      );
    }
    return errors.remove(key);
  }

  checkRX2Freq(val, errors = this.state.errors) {
    if (!/^[0-9]+(\.[0-9]+)?$/.test(val)) {
      return errors.add(
        'FE_INVALIDNUM',
        'rx2freq',
        { message: this.intlMsg.errorMsg('FE_INVALIDNUM') },
      );
    }
    if (!/^[0-9]+(\.[0-9]{0,4})?$/.test(val)) {
      return errors.add(
        'FE_PREC4',
        'rx2freq',
        { message: this.intlMsg.errorMsg('FE_PREC4') },
      );
    }
    if (Number(val) < 100 || Number(val) > 16700) {
      return errors.add(
        'FE_OUTOFRANGE',
        'rx2freq',
        { message: this.intlMsg.errorMsg('FE_OUTOFRANGE') },
      );
    }
    return errors.remove('rx2freq');
  }

  handleOnHide() {
    this.props.onHide();
    this.setState({
      submitted: false,
      errors: new ErrorSet(),
    });
  }

  handleChangeName(e) {
    let { errors } = this.state;
    const name = _.trim(e.target.value);
    errors = name.length === 0 ? errors.add('FE_EMPTY', 'name') : errors.remove('name');
    this.setState({ errors, name });
  }

  handleChangeSelect(key, value) {
    const { errors } = this.state;
    this.setState({ [key]: value, errors: errors.remove(key) });
  }

  handleChangeKeys(key, e) {
    const val = _.trim(e.target.value);
    let { errors } = this.state;
    errors = this.checkKeys(key, val, errors);
    this.setState({ errors, [key]: val });
  }

  handleChangeFreq(e) {
    const rx2freq = _.trim(e.target.value);
    let { errors } = this.state;
    errors = this.checkRX2Freq(rx2freq, errors);
    this.setState({ rx2freq, errors });
  }

  handleChangeFcntdown(e) {
    const { errors } = this.state;
    const fcntdown = _.trim(e.target.value);
    if (fcntdown.length === 0 ||
        fcntdown.indexOf('-') > -1 ||
        !_.isInteger(Number(fcntdown))) {
      this.setState({ errors: errors.add('FE_INVALIDFCNT', 'fcntdown') });
    } else {
      this.setState({ errors: errors.remove('fcntdown') });
    }
    this.setState({ fcntdown });
  }

  handleOnConfirm() {
    const { name, errors, band, rx2dr, rx2freq, appskey, nwkskey, fcntdown } = this.state;
    const { appId, onSuccess, data } = this.props;

    this.setState({ submitted: true });

    if (!errors.isEmpty()) {
      return;
    }

    callAPI({
      endpoint: `/lora/apps/${appId}/broadcasts/${data.devaddr}`,
      method: 'PUT',
      body: {
        appskey,
        nwkskey,
        name,
        band,
        fcntdown: Number(fcntdown),
        rx2dr,
        rx2freq: Number(rx2freq) * 10000,
      },
    }).then(() => {
      onSuccess();
      this.handleOnHide();
    }).catch(() => {});
  }

  render() {
    const {
      showModal,
      bandsOpts,
      errors,
      submitted,
      name = '',
      band = '',
      rx2dr = '',
      rx2freq = '',
      appskey = '',
      nwkskey = '',
      fcntdown = '',
    } = this.state;
    return (
      <Modal
        show={showModal}
        onHide={() => this.handleOnHide()}
        bsClass="aisz-modal-light"
      >
        <Modal.Header closeButton >
          {this.intlMsg.msg('editmodal.header')}
        </Modal.Header>
        <Modal.Body>
          <Form horizontal>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('label.name')}&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={name}
                  bsClass="aisz-form-control-f"
                  placeholder={this.intlMsg.msg('add.placeholder')}
                  onChange={this.handleChangeName}
                />
                <ControlTips
                  show={errors.has('name') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('name'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('addrlist.fcntdown')}&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  type="number"
                  value={fcntdown}
                  bsClass="aisz-form-control-f"
                  onChange={e => this.handleChangeFcntdown(e)}
                />
                <ControlTips
                  show={errors.has('fcntdown') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('fcntdown'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('addressmodal.band')}&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Select
                  value={band}
                  options={bandsOpts}
                  onChange={va => this.handleChangeSelect('band', va)}
                />
                <ControlTips
                  show={errors.has('band') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('band'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  RX2DR&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Select
                  value={rx2dr}
                  options={kRX2DROptions}
                  onChange={v => this.handleChangeSelect('rx2dr', v)}
                />
                <ControlTips
                  show={errors.has('rx2dr') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('rx2dr'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  RX2 Frequency&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={rx2freq}
                  bsClass="aisz-form-control-f"
                  placeholder="RX2 Frequency"
                  onChange={e => this.handleChangeFreq(e)}
                />
                <ControlTips
                  show={errors.has('rx2freq') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('rx2freq'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('addrlist.appskey')}&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={appskey}
                  bsClass="aisz-form-control-f"
                  placeholder="s"
                  onChange={e => this.handleChangeKeys('appskey', e)}
                />
                <ControlTips
                  show={errors.has('appskey') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('appskey'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={3}>
                <ControlLabel bsClass="aisz-control-label">
                  {this.intlMsg.msg('addrlist.nwkskey')}&nbsp;*
                </ControlLabel>
              </Col>
              <Col md={6}>
                <FormControl
                  value={nwkskey}
                  bsClass="aisz-form-control-f"
                  placeholder="s"
                  onChange={e => this.handleChangeKeys('nwkskey', e)}
                />
                <ControlTips
                  show={errors.has('nwkskey') && submitted}
                  message={this.intlMsg.errorMsg(errors.get('nwkskey'))}
                  azStyle="danger"
                  placement="right"
                />
              </Col>
            </FormGroup>
            <FormGroup >
              <Col md={6} mdOffset={3}>
                <Button
                  bsStyle="aisz-primary"
                  className={styles.fullWidth}
                  onClick={() => this.handleOnConfirm()}
                >
                  {this.intlMsg.msg('add.confirm')}
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

AddModal.propTypes = propTypes;

const mapStateToProps = state => ({
  bandsOpts: enumsToOptions('bands', state),
});

const mapDispatchToProps = {
  getBands: enumsActions.bands,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AddModal));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/coms/EditAddress/index.jsx